<template>
  <div id="lip-counsel-container" class="lip-counsel-container">
    <div class="lip-counsel-section">
      <div
        v-for="step in steps.Steps"
        v-show="stepCount === step.StepNo"
        :key="step.stepNo"
        class="lip-counsel-content"
        :stepcount="step.StepNo"
      >
        <span class="question">
          <span class="question-number">Q{{ step.StepNo }}</span>
          {{ step.StepQuestionText }}</span
        >
        <ul class="lip-counsel-answers">
          <li
            v-for="choice in step.Choices"
            :key="choice.ChoiceText"
            class="lip-counsel-item"
            @click="
              answer(step, choice);
              getTaggingInfo(pagecategoryData, step.StepQuestionText, choice.ChoiceText);
            "
          >
            <span v-if="step.StepNo >= steps.Steps.length">
              <a :href="resultUrlNo + choice.ChoiceNo">
                <img :src="choice.ChoiceImage" alt="img" />
                <img :src="choicesBorderImage" alt="img" />
              </a>
            </span>
            <span v-else>
              <img :src="choice.ChoiceImage" alt="" />
              <img :src="choicesBorderImage" alt="img" />
            </span>
          </li>
        </ul>
      </div>
      <div class="progress-wrapper">
        <div class="progress-container">
          <div class="progress">
            <div class="percent"></div>
          </div>
          <div class="steps">
            <div v-for="step in steps.Steps" :id="step.StepNo" :key="step.StepNo" class="step">
              <span v-if="stepCount === step.StepNo"><img :src="step.StepImage" alt="" /></span>
            </div>
          </div>
        </div>
      </div>
      <span v-if="stepCount !== 1" class="back-btn"
        ><img :src="backButtonImage" alt="" @click="previous()"
      /></span>
    </div>
    <span class="border-box"></span>
    <span class="border-box"></span>
  </div>
</template>

<script>
import { AnalyticsHandler } from '../../../../../../Foundation/Core/code/Scripts/analyticsHandler/AnalyticsHandler';
export default {
  name: 'PrQuestion',
  props: {
    initialData: { type: Object, required: true },
    pagecategoryData: { type: String, required: false },
    choicesBorderImage: { type: String, required: false },
    backButtonImage: { type: String, required: false },
    resultPageUrl: { type: String, required: false },
  },
  data() {
    return {
      answers: [],
      stepCount: 1,
      steps: this.initialData,
      choiceno: [],
      choicenoTotal: {},
      choicenoUrlNo: '',
      resultUrl: this.resultPageUrl,
      resultUrlNo: {},
    };
  },
  methods: {
    answer: function (qno, choice) {
      this.answers.push({ 'question no': qno.StepNo, 'choice no': choice.ChoiceNo });
      this.stepCount++;

      if (this.stepCount == this.steps.Steps.length) {
        this.choiceno.push(choice.ChoiceNo);
        this.choicenoTotal = this.choiceno.length;
        var i;
        for (i = 0; i < this.choicenoTotal; i++) {
          this.choicenoUrlNo = this.choicenoUrlNo + '' + this.choiceno[i];
          this.resultUrlNo = this.resultUrl + '?id=' + this.choicenoUrlNo;
        }
      } else if (this.stepCount > this.steps.Steps.length) {
        this.stepCount--;
      } else {
        this.choiceno.push(choice.ChoiceNo);
      }
    },
    previous: function () {
      if (this.stepCount > 1) {
        this.stepCount--;
        this.choiceno.splice(this.stepCount - 1, 1);
        this.choicenoUrlNo = '';
      } else {
        window.history.back();
      }
    },
    getTaggingInfo(pagecategory, action, label) {
      AnalyticsHandler.getAnalyticsHandler().push({
        type: 'userActionEvent',
        ecommerce: 'undefined',
        category: pagecategory,
        action: action,
        label: label,
      });
    },
  },
};
</script>
